




























































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

// Импорт ради Array.prototype.realValuesOrEmpty() в зонных фильтрах
import '@/extensions';
import Toast from '@/mixins/toast';

import Card from '@/components/UI/Card.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';

import MmHintedButton from '../../components/MmHintedButton.vue';
import MmStates from '../../components/MmStates.vue';
import MmStatusBadge from '../../components/MmStatusBadge.vue';
import MmTable from '../../components/MmTable.vue';
import TaskCreateMenu from './TaskCreateMenu.vue';
import TasksListFilters from './TasksListFilters.vue';
import ZoningUnresolvedBanner from './ZoningUnresolvedBanner.vue';

import { createCancelSource } from '../../api/mmHttp';
import {
	buildPageQuery,
	createPaginationState,
	createSortingState,
	MmPaginationState,
	MmSortingState,
} from '../../api/pagination';
import { fetchTasks } from '../../api/tasks';
import {
	MM_TASK_LIST_CAPABILITIES,
	MM_ZONING_MODELS_REGISTRY,
	MmTaskListCapabilities,
} from '../../config/features';
import { formatDiagnostics, isCanceled, MmError, toMmError } from '../../core/errors';
import { formatDateTime, orDash } from '../../core/format';
import { getSessionStore, retryMobileSession } from '../../core/session';
import { listTaskStatusesByGroup } from '../../core/statuses';
import { MmTask } from '../../types/domain';
import { MmTaskListFilters } from '../../types/dto';
import { MmErrorCode, MmTaskType } from '../../types/enums';

const KEY = 'priceMonitoring.mobileMonitoring.tasks.';

const DEFAULT_STATUSES: string[] = listTaskStatusesByGroup('active');

const DEFAULT_SORT_FIELD = 'createdAt';
const DEFAULT_SORT_ORDER: 'asc' | 'desc' = 'desc';

const HIGHLIGHT_MS = 6000;

const COLUMN_WIDTHS = {
	type: 150,
	status: 140,
	competitor: 250,
	address: 240,
	format: 150,
	region: 150,
	cluster: 150,
	auditor: 190,
	createdAt: 170,
	/** 90px вместо расчётных 62px — чтобы заголовок «Действия» не обрезался в шапке */
	actions: 90,
};

interface MmTaskListRequestFilters extends Partial<MmTaskListFilters> {
	createdFrom: string | null;
	createdTo: string | null;
}

interface TaskListAppliedFilters {
	batchId: string | null;
	statuses: string[];
	types: string[];
	competitorQuery: string;
	formats: number[];
	formatNames: string[];
	regions: number[];
	regionNames: string[];
	clusters: number[];
	clusterNames: string[];
	createdFrom: string | null;
	createdTo: string | null;
	auditorId: number | null;
	auditorLogin: string | null;
}

interface MmTaskListSnapshot {
	tradingId: number;
	batchId: string | null;
	statuses: string[];
	types: string[];
	competitorQuery: string;
	formats: number[];
	formatNames: string[];
	regions: number[];
	regionNames: string[];
	clusters: number[];
	clusterNames: string[];
	createdFrom: string | null;
	createdTo: string | null;
	auditorId: number | null;
	auditorLogin: string | null;
	pagination: MmPaginationState;
	sorting: MmSortingState;
	scrollTop: number;
}

let listSnapshot: MmTaskListSnapshot | null = null;

/** Тип описан структурно: импортировать его из .vue TypeScript не умеет */
interface MmTableChange {
	pagination: MmPaginationState;
	sorter: MmSortingState;
	filters: { [key: string]: any };
}

@Component({
	components: {
		Card,
		ColumnTitleContent,
		MmHintedButton,
		MmStates,
		MmStatusBadge,
		MmTable,
		TaskCreateMenu,
		TasksListFilters,
		ZoningUnresolvedBanner,
	},
})
export default class TasksList extends Mixins(Toast) {
	@Prop({ default: null }) readonly tradingId!: number | null;

	/** Проп объявлен, хотя не используется: иначе он осел бы в $attrs и уехал атрибутом в DOM */
	@Prop({ default: null }) readonly tradingName!: string | null;

	/** ant-design-vue 1.7.8 не размонтирует открытую вкладку, поэтому запросы идут только при isActive */
	@Prop({ default: false }) readonly isActive!: boolean;

	statuses: string[] = DEFAULT_STATUSES.slice();
	types: string[] = [];
	competitorQuery: string = '';
	/** Хранятся как есть, вместе с нулём, который означает «Все» */
	formats: number[] = [];
	formatNames: string[] = [];
	regions: number[] = [];
	regionNames: string[] = [];
	clusters: number[] = [];
	clusterNames: string[] = [];
	createdFrom: string | null = null;
	createdTo: string | null = null;
	/** ID — для селекта; в запрос уезжает логин. */
	auditorId: number | null = null;
	auditorLogin: string | null = null;

	batchId: string | null = null;

	private appliedFilters: TaskListAppliedFilters | null = null;

	rows: MmTask[] = [];
	pagination: MmPaginationState = createPaginationState();
	sorting: MmSortingState = createSortingState(
		MM_TASK_LIST_CAPABILITIES.createdAtSort ? DEFAULT_SORT_FIELD : undefined,
		MM_TASK_LIST_CAPABILITIES.createdAtSort ? DEFAULT_SORT_ORDER : undefined,
	);
	isLoading: boolean = false;
	loadError: MmError | null = null;

	/** Обычный объект, а не Set: Vue 2 к Set нереактивен, помогает только замена целиком */
	highlightedIds: { [key: string]: boolean } = {};

	/** Хранилище создано через Vue.observable, поэтому за ним работает @Watch */
	session = getSessionStore();

	private hasLoadedOnce: boolean = false;
	private needsReload: boolean = false;
	private listSource: any = null;
	private highlightTimer: number | null = null;

	private isHighlightPending: boolean = false;
	private pendingScrollTop: number | null = null;

	created(): void {
		this.restoreSnapshot();
		this.commitAppliedFilters();
	}

	mounted(): void {
		this.loadTasks();
	}

	beforeDestroy(): void {
		this.saveSnapshot();
		this.clearHighlightTimer();
		this.cancelPendingRequests();
	}

	@Watch('session.readyTick')
	onSessionReady(): void {
		if (!this.isActive) {
			this.needsReload = true;

			return;
		}

		this.reloadAll();
	}

	@Watch('isActive')
	onActiveChanged(next: boolean): void {
		if (next === true && this.needsReload) {
			this.needsReload = false;
			this.reloadAll();
		}
	}

	get capabilities(): MmTaskListCapabilities {
		return MM_TASK_LIST_CAPABILITIES;
	}

	get isNetworkMissing(): boolean {
		return this.tradingId === null;
	}

	get showZoningBanner(): boolean {
		return MM_ZONING_MODELS_REGISTRY && this.tradingId !== null;
	}

	get networkMissingReason(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.networkNotSelected') as string;
	}

	get createDisabledReason(): string {
		return this.$t(KEY + 'createDisabledNoNetwork') as string;
	}

	get foundText(): string {
		return this.$t(KEY + 'foundCount', { count: this.pagination.total }) as string;
	}

	get isDefaultStatusSelection(): boolean {
		if (this.statuses.length !== DEFAULT_STATUSES.length) {
			return false;
		}

		for (let i = 0; i < DEFAULT_STATUSES.length; i += 1) {
			if (this.statuses.indexOf(DEFAULT_STATUSES[i]) < 0) {
				return false;
			}
		}

		return true;
	}

	get hasUserFilters(): boolean {
		if (this.batchId !== null) {
			return true;
		}

		if (!this.isDefaultStatusSelection) {
			return true;
		}

		if (this.types.length > 0) {
			return true;
		}

		if (this.competitorQuery !== '') {
			return true;
		}

		if (this.formats.slice().realValuesOrEmpty().length > 0) {
			return true;
		}

		if (this.regions.slice().realValuesOrEmpty().length > 0) {
			return true;
		}

		if (this.clusters.slice().realValuesOrEmpty().length > 0) {
			return true;
		}

		if (this.createdFrom !== null || this.createdTo !== null) {
			return true;
		}

		if (this.auditorLogin !== null) {
			return true;
		}

		return false;
	}

	/** realValuesOrEmpty применяем только к зоне, где 0 значит «Все»; к товарным уровням — никогда */
	get listFilters(): MmTaskListRequestFilters {
		const state = this.appliedFilters != null ? this.appliedFilters : this.readCurrentFilterState();

		return this.buildListFiltersFromState(state);
	}

	get filtersDirty(): boolean {
		if (this.appliedFilters === null) {
			return false;
		}

		return JSON.stringify(this.readCurrentFilterState()) !== JSON.stringify(this.appliedFilters);
	}

	private readCurrentFilterState(): TaskListAppliedFilters {
		return {
			batchId: this.batchId,
			statuses: this.statuses.slice(),
			types: this.types.slice(),
			competitorQuery: this.competitorQuery,
			formats: this.formats.slice(),
			formatNames: this.formatNames.slice(),
			regions: this.regions.slice(),
			regionNames: this.regionNames.slice(),
			clusters: this.clusters.slice(),
			clusterNames: this.clusterNames.slice(),
			createdFrom: this.createdFrom,
			createdTo: this.createdTo,
			auditorId: this.auditorId,
			auditorLogin: this.auditorLogin,
		};
	}

	private commitAppliedFilters(): void {
		this.appliedFilters = this.readCurrentFilterState();
	}

	private buildListFiltersFromState(state: TaskListAppliedFilters): MmTaskListRequestFilters {
		const caps = this.capabilities;

		return {
			statuses: caps.statusFilter ? state.statuses.slice() : [],
			types: caps.typeFilter ? state.types.slice() : [],
			q: caps.competitorSearch && state.competitorQuery !== '' ? state.competitorQuery : null,
			formats: caps.zoneFilter ? state.formats.slice().realValuesOrEmpty() : [],
			formatNames: caps.zoneFilter ? state.formatNames.slice() : [],
			regions: caps.zoneFilter ? state.regions.slice().realValuesOrEmpty() : [],
			regionNames: caps.zoneFilter ? state.regionNames.slice() : [],
			clusters: caps.zoneFilter ? state.clusters.slice().realValuesOrEmpty() : [],
			clusterNames: caps.zoneFilter ? state.clusterNames.slice() : [],
			groups: [],
			categories: [],
			subcategories: [],
			competitorCodes: [],
			auditorLogins: caps.auditorFilter && state.auditorLogin !== null ? [state.auditorLogin] : [],
			batchId: state.batchId,
			createdFrom: caps.createdPeriodFilter ? state.createdFrom : null,
			createdTo: caps.createdPeriodFilter ? state.createdTo : null,
		};
	}

	/** Колонки слотами с key: вложенный dataIndex уехал бы в запрос как имя поля сортировки */
	get columns(): any[] {
		const caps = this.capabilities;

		return [
			this.buildColumn('type', 'colType', COLUMN_WIDTHS.type, 'typeCell', caps.typeSort, 'left'),
			this.buildColumn('status', 'colStatus', COLUMN_WIDTHS.status, 'statusCell', caps.statusSort),
			this.buildColumn(
				'competitorCode',
				'colCompetitor',
				COLUMN_WIDTHS.competitor,
				'competitorCell',
				caps.competitorSort,
			),
			this.buildColumn('address', 'colAddress', COLUMN_WIDTHS.address, 'addressCell', false),
			this.buildColumn('storeFormatName', 'colFormat', COLUMN_WIDTHS.format, 'formatCell', false),
			this.buildColumn('storeRegionName', 'colRegion', COLUMN_WIDTHS.region, 'regionCell', false),
			this.buildColumn('storeClusterName', 'colCluster', COLUMN_WIDTHS.cluster, 'clusterCell', false),
			this.buildColumn('auditorLogin', 'colAuditor', COLUMN_WIDTHS.auditor, 'auditorCell', false),
			this.buildColumn('createdAt', 'colCreatedAt', COLUMN_WIDTHS.createdAt, 'createdAtCell', caps.createdAtSort),
			{
				key: 'actions',
				title: this.$t('shared.labels.actions'),
				scopedSlots: { customRender: 'actions' },
				fixed: 'right',
				width: COLUMN_WIDTHS.actions,
			},
		];
	}

	get titledColumns(): any[] {
		const source = this.columns;
		const result: any[] = [];

		for (let i = 0; i < source.length; i += 1) {
			const column = source[i];

			if (column.slots && column.slots.title && column.slotColumnTitleData) {
				result.push(column);
			}
		}

		return result;
	}

	get scrollX(): number {
		return COLUMN_WIDTHS.type
			+ COLUMN_WIDTHS.status
			+ COLUMN_WIDTHS.competitor
			+ COLUMN_WIDTHS.address
			+ COLUMN_WIDTHS.format
			+ COLUMN_WIDTHS.region
			+ COLUMN_WIDTHS.cluster
			+ COLUMN_WIDTHS.auditor
			+ COLUMN_WIDTHS.createdAt
			// Ширина колонки действий входит в scroll.x, иначе закрепление колонок ломается
			+ COLUMN_WIDTHS.actions;
	}

	get isInitialLoading(): boolean {
		return this.isLoading && !this.hasLoadedOnce;
	}

	get rowClassName(): (record: MmTask, index: number) => string {
		const highlighted = this.highlightedIds;

		return function buildRowClass(record: MmTask): string {
			const classes = ['sm-mobilemon__row--clickable'];

			if (record && highlighted[String(record.id)] === true) {
				classes.push('sm-mobilemon__row--fresh');
			}

			return classes.join(' ');
		};
	}

	get customRow(): (record: MmTask, index: number) => any {
		const self = this;

		return function buildRow(record: MmTask): any {
			return {
				on: {
					click: function onRowClick(event: any): void {
						self.handleRowClick(record, event);
					},
				},
			};
		};
	}

	get emptyStateName(): string {
		if (this.loadError === null) {
			return 'empty';
		}

		if (this.loadError.code === MmErrorCode.FORBIDDEN) {
			return 'forbidden';
		}

		/** UNAUTHORIZED сюда не добавлять: он лечится повторным обменом сессии, а не соединением */
		if (
			this.loadError.code === MmErrorCode.SERVER
			|| this.loadError.code === MmErrorCode.NETWORK
			|| this.loadError.code === MmErrorCode.TIMEOUT
		) {
			return 'unavailable';
		}

		return 'error';
	}

	get emptyStateTitle(): string {
		if (this.emptyStateName === 'forbidden' || this.emptyStateName === 'unavailable') {
			return '';
		}

		if (this.loadError !== null) {
			return this.$t(KEY + 'loadError') as string;
		}

		return this.$t(KEY + (this.hasUserFilters ? 'emptyFiltered' : 'emptyTitle')) as string;
	}

	get emptyStateText(): string {
		if (this.emptyStateName === 'forbidden' || this.emptyStateName === 'unavailable') {
			return '';
		}

		if (this.loadError !== null) {
			const message = this.loadError.message ? String(this.loadError.message).trim() : '';

			return message !== '' ? message : (this.$t(KEY + 'loadErrorHint') as string);
		}

		return '';
	}

	get isLoadErrorRetryable(): boolean {
		return this.loadError !== null && this.loadError.retryable;
	}

	get errorDiagnostics(): string {
		return this.loadError !== null ? formatDiagnostics(this.loadError.diagnostics) : '';
	}

	get loadErrorText(): string {
		return this.loadError !== null && this.loadError.message
			? String(this.loadError.message).trim()
			: '';
	}

	get showResetCta(): boolean {
		return this.loadError === null && this.hasUserFilters;
	}

	get showCreateCta(): boolean {
		return this.loadError === null && !this.hasUserFilters;
	}

	private reloadAll(): void {
		this.loadTasks();

		const filters: any = this.$refs.filters;

		if (filters && typeof filters.reloadDictionaries === 'function') {
			filters.reloadDictionaries();
		}
	}

	private loadTasks(): void {
		if (this.tradingId === null) {
			return;
		}

		if (this.listSource !== null) {
			this.listSource.cancel();
		}

		const source = createCancelSource();

		this.listSource = source;
		this.isLoading = true;

		fetchTasks(
			this.tradingId,
			this.listFilters,
			buildPageQuery(this.pagination, this.sorting),
			{ cancelToken: source.token },
		)
			.then((page) => {
				if (this.listSource !== source) {
					return;
				}

				/** Флаг поднимаем здесь, а не в finally: nextTick с восстановлением прокрутки планируется раньше */
				this.pagination.total = page.totalElements;

				const pageCount = this.pagination.pageSize > 0
					? Math.ceil(page.totalElements / this.pagination.pageSize)
					: 1;
				const lastPage = pageCount > 0 ? pageCount : 1;

				if (this.pagination.current > lastPage) {
					this.pagination.current = lastPage;
					this.listSource = null;
					this.loadTasks();

					return;
				}

				this.hasLoadedOnce = true;
				this.rows = page.content ? page.content : [];
				this.loadError = null;
				this.armHighlightTimer();
				this.restoreScrollPosition();
			})
			.catch((error) => {
				if (isCanceled(error) || this.listSource !== source) {
					return;
				}

				this.hasLoadedOnce = true;
				this.rows = [];
				this.pagination.total = 0;
				this.loadError = toMmError(error, 'tasks/list');
				this.pendingScrollTop = null;
			})
			.finally(() => {
				if (this.listSource !== source) {
					return;
				}

				this.listSource = null;
				this.isLoading = false;
			});
	}

	private cancelPendingRequests(): void {
		if (this.listSource !== null) {
			this.listSource.cancel();
			this.listSource = null;
		}
	}

	private applyFilterChange(): void {
		this.pagination.current = 1;
		this.pendingScrollTop = 0;
		this.loadTasks();
	}

	handleStatusesChange(next: string[]): void {
		this.statuses = next ? next.slice() : [];
	}

	handleTypesChange(next: string[]): void {
		this.types = next ? next.slice() : [];
	}

	handleCompetitorChange(next: string): void {
		this.competitorQuery = next ? next : '';
	}

	handleZoneChange(zone: {
		formats: number[];
		formatNames: string[];
		regions: number[];
		regionNames: string[];
		clusters: number[];
		clusterNames: string[];
	}): void {
		this.formats = zone && zone.formats ? zone.formats.slice() : [];
		this.formatNames = zone && zone.formatNames ? zone.formatNames.slice() : [];
		this.regions = zone && zone.regions ? zone.regions.slice() : [];
		this.regionNames = zone && zone.regionNames ? zone.regionNames.slice() : [];
		this.clusters = zone && zone.clusters ? zone.clusters.slice() : [];
		this.clusterNames = zone && zone.clusterNames ? zone.clusterNames.slice() : [];
	}

	handlePeriodChange(from: string | null, to: string | null): void {
		this.createdFrom = from;
		this.createdTo = to;
	}

	handleAuditorChange(id: number | null, login: string | null): void {
		this.auditorId = id;
		this.auditorLogin = login;
	}

	handleResetFilters(): void {
		this.batchId = null;
		this.statuses = DEFAULT_STATUSES.slice();
		this.types = [];
		this.competitorQuery = '';
		this.formats = [];
		this.formatNames = [];
		this.regions = [];
		this.regionNames = [];
		this.clusters = [];
		this.clusterNames = [];
		this.createdFrom = null;
		this.createdTo = null;
		this.auditorId = null;
		this.auditorLogin = null;
		this.sorting = createSortingState(
			this.capabilities.createdAtSort ? DEFAULT_SORT_FIELD : undefined,
			this.capabilities.createdAtSort ? DEFAULT_SORT_ORDER : undefined,
		);

		this.commitAppliedFilters();
		this.applyFilterChange();

		/** Через nextTick: справочники читают зону из свойств, а те обновятся только на следующем тике */
		this.$nextTick(() => {
			const filters: any = this.$refs.filters;

			if (filters && typeof filters.reloadDictionaries === 'function') {
				filters.reloadDictionaries();
			}
		});
	}

	handleTableChange(event: MmTableChange): void {
		const isSortChanged = this.sorting.field !== event.sorter.field
			|| this.sorting.order !== event.sorter.order;

		this.pagination.pageSize = event.pagination.pageSize;
		this.sorting = { field: event.sorter.field, order: event.sorter.order };
		this.pagination.current = isSortChanged ? 1 : event.pagination.current;

		this.pendingScrollTop = 0;
		this.loadTasks();
	}

	handleRefresh(): void {
		this.loadTasks();
	}

	handleApplyFilters(): void {
		if (this.isLoading) {
			return;
		}

		this.commitAppliedFilters();
		this.applyFilterChange();
	}

	handleRetry(): void {
		if (this.loadError !== null && this.loadError.code === MmErrorCode.UNAUTHORIZED) {
			retryMobileSession();

			return;
		}

		this.loadTasks();
	}

	handleCreate(type: MmTaskType): void {
		this.$emit('create', type);
	}

	handleOpen(record: MmTask): void {
		this.openTask(record);
	}

	/** Выделение текста не должно открывать карточку: mouseup приходит на строку */
	handleRowClick(record: MmTask, event: any): void {
		if (!record || !record.id) {
			return;
		}

		const selection = window.getSelection ? window.getSelection() : null;

		if (selection && String(selection.toString()).trim() !== '') {
			return;
		}

		if (this.isInteractiveTarget(event)) {
			return;
		}

		this.openTask(record);
	}

	private openTask(record: MmTask): void {
		if (!record || !record.id) {
			return;
		}

		this.rememberScrollPosition();
		this.$emit('open', record.id);
	}

	reload(): void {
		this.loadTasks();
	}

	openBatch(batchId: string | null): void {
		if (batchId === null || batchId === undefined || batchId === '') {
			return;
		}

		this.batchId = batchId;
		this.statuses = [];
		this.types = [];
		this.competitorQuery = '';
		this.formats = [];
		this.formatNames = [];
		this.regions = [];
		this.regionNames = [];
		this.clusters = [];
		this.clusterNames = [];
		this.createdFrom = null;
		this.createdTo = null;
		this.auditorId = null;
		this.auditorLogin = null;

		this.commitAppliedFilters();
		this.pagination.current = 1;
		this.pendingScrollTop = 0;
		this.applyFilterChange();
	}

	reloadAfterCreate(createdTaskIds: string[] | null, createdCount: number): void {
		const count = typeof createdCount === 'number' && createdCount > 0
			? createdCount
			: (createdTaskIds ? createdTaskIds.length : 0);

		this.showInfo(this.$t(KEY + 'createdCount', { count: count }) as string);
		this.applyHighlight(createdTaskIds);

		this.pagination.current = 1;
		this.pendingScrollTop = 0;
		this.loadTasks();
	}

	readStoreText(row: MmTask, field: string): string {
		const store: any = row && row.competitorStore ? row.competitorStore : null;

		return orDash(store ? store[field] : null);
	}

	/** Имена намеренно не совпадают с импортами: одноимённый метод звал бы сам себя */
	dashed(value: string | number | null | undefined): string {
		return orDash(value);
	}

	dateTimeText(value: string | null | undefined): string {
		return formatDateTime(value);
	}

	private buildColumn(
		key: string,
		titleKey: string,
		width: number,
		slotName: string,
		sortable: boolean,
		fixed?: string,
	): any {
		const column: any = {
			key: key,
			/** Заголовок задаётся слотом: плоский title рядом ставить нельзя, слот тогда не подставится */
			slots: { title: key + 'ColumnTitle' },
			slotColumnTitleData: {
				text: this.$t(KEY + titleKey) as string,
			},
			width: width,
			scopedSlots: { customRender: slotName },
		};

		/** Ключ fixed кладём только по факту: ant считает свойство заданным даже со значением undefined */
		if (fixed !== undefined) {
			column.fixed = fixed;
		}

		/** sorter: true без функции сравнения, иначе ant пересортирует текущую страницу поверх серверной */
		if (sortable) {
			column.sorter = true;
			column.sortOrder = this.readSortOrder(key);
		}

		return column;
	}

	private readSortOrder(field: string): string | boolean {
		if (this.sorting.field !== field || this.sorting.order === null) {
			return false;
		}

		return this.sorting.order === 'desc' ? 'descend' : 'ascend';
	}

	private isInteractiveTarget(event: any): boolean {
		const target: any = event && event.target ? event.target : null;

		if (!target || typeof target.closest !== 'function') {
			return false;
		}

		return target.closest('a, button, input, textarea, select, .ant-select, .ant-checkbox-wrapper') !== null;
	}

	private applyHighlight(ids: string[] | null): void {
		this.clearHighlightTimer();

		if (!ids || ids.length === 0) {
			this.highlightedIds = {};
			this.isHighlightPending = false;

			return;
		}

		const map: { [key: string]: boolean } = {};

		for (let i = 0; i < ids.length; i += 1) {
			map[String(ids[i])] = true;
		}

		this.highlightedIds = map;

		this.isHighlightPending = true;
	}

	private armHighlightTimer(): void {
		if (!this.isHighlightPending) {
			return;
		}

		this.isHighlightPending = false;

		this.highlightTimer = window.setTimeout(() => {
			this.highlightedIds = {};
			this.highlightTimer = null;
		}, HIGHLIGHT_MS);
	}

	private clearHighlightTimer(): void {
		if (this.highlightTimer !== null) {
			window.clearTimeout(this.highlightTimer);
			this.highlightTimer = null;
		}
	}

	private readScrollBody(): any {
		if (!this.$el || typeof this.$el.querySelector !== 'function') {
			return null;
		}

		return this.$el.querySelector('.ant-table-body');
	}

	private rememberScrollPosition(): void {
		const body = this.readScrollBody();

		this.pendingScrollTop = body ? body.scrollTop : null;
	}

	private restoreScrollPosition(): void {
		const target = this.pendingScrollTop;

		this.pendingScrollTop = null;

		if (target === null) {
			return;
		}

		this.$nextTick(() => {
			const body = this.readScrollBody();

			if (body) {
				body.scrollTop = target;
			}
		});
	}

	private saveSnapshot(): void {
		if (this.tradingId === null) {
			return;
		}

		const body = this.readScrollBody();

		listSnapshot = {
			tradingId: this.tradingId,
			batchId: this.batchId,
			statuses: this.statuses.slice(),
			types: this.types.slice(),
			competitorQuery: this.competitorQuery,
			formats: this.formats.slice(),
			formatNames: this.formatNames.slice(),
			regions: this.regions.slice(),
			regionNames: this.regionNames.slice(),
			clusters: this.clusters.slice(),
			clusterNames: this.clusterNames.slice(),
			createdFrom: this.createdFrom,
			createdTo: this.createdTo,
			auditorId: this.auditorId,
			auditorLogin: this.auditorLogin,
			pagination: {
				current: this.pagination.current,
				pageSize: this.pagination.pageSize,
				total: 0,
			},
			sorting: { field: this.sorting.field, order: this.sorting.order },
			scrollTop: body ? body.scrollTop : 0,
		};
	}

	private restoreSnapshot(): void {
		const snapshot = listSnapshot;

		if (snapshot === null) {
			return;
		}

		listSnapshot = null;

		if (this.tradingId === null || snapshot.tradingId !== this.tradingId) {
			return;
		}

		this.batchId = snapshot.batchId;
		this.statuses = snapshot.statuses.slice();
		this.types = snapshot.types.slice();
		this.competitorQuery = snapshot.competitorQuery;
		this.formats = snapshot.formats.slice();
		this.formatNames = snapshot.formatNames.slice();
		this.regions = snapshot.regions.slice();
		this.regionNames = snapshot.regionNames.slice();
		this.clusters = snapshot.clusters.slice();
		this.clusterNames = snapshot.clusterNames.slice();
		this.createdFrom = snapshot.createdFrom;
		this.createdTo = snapshot.createdTo;
		this.auditorId = snapshot.auditorId;
		this.auditorLogin = snapshot.auditorLogin;
		this.pagination.current = snapshot.pagination.current;
		this.pagination.pageSize = snapshot.pagination.pageSize;
		this.sorting = { field: snapshot.sorting.field, order: snapshot.sorting.order };
		this.pendingScrollTop = snapshot.scrollTop;
	}
}
